/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 * A type of `ModelSerializer` that uses
 * hyperlinked relationships with compound keys instead
 * of primary key relationships.  Specifically:
 * * A 'url' field is included instead of the 'id' field.
 * * Relationships to other instances are hyperlinks, instead of primary keys.
 * NOTE: this only works with DRF 3.1.0 and above.
 * @export
 * @interface PatchedOneDWaterLevelPredefined
 */
export interface PatchedOneDWaterLevelPredefined {
  /**
   *
   */
  readonly url?: string;
  /**
   *
   */
  readonly simulation?: string;
  /**
   *
   */
  readonly uid?: string;
  /**
   *
   */
  readonly id?: number;
}

/**
 * Check if a given object implements the PatchedOneDWaterLevelPredefined interface.
 */
export function instanceOfPatchedOneDWaterLevelPredefined(
  value: object
): value is PatchedOneDWaterLevelPredefined {
  return true;
}

export function PatchedOneDWaterLevelPredefinedFromJSON(
  json: any
): PatchedOneDWaterLevelPredefined {
  return PatchedOneDWaterLevelPredefinedFromJSONTyped(json, false);
}

export function PatchedOneDWaterLevelPredefinedFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PatchedOneDWaterLevelPredefined {
  if (json == null) {
    return json;
  }
  return {
    url: json["url"] == null ? undefined : json["url"],
    simulation: json["simulation"] == null ? undefined : json["simulation"],
    uid: json["uid"] == null ? undefined : json["uid"],
    id: json["id"] == null ? undefined : json["id"],
  };
}

export function PatchedOneDWaterLevelPredefinedToJSON(json: any): PatchedOneDWaterLevelPredefined {
  return PatchedOneDWaterLevelPredefinedToJSONTyped(json, false);
}

export function PatchedOneDWaterLevelPredefinedToJSONTyped(
  value?: Omit<PatchedOneDWaterLevelPredefined, "url" | "simulation" | "uid" | "id"> | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {};
}
